import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EzAlertComponent } from 'src/shared/ez-alert/ez-alert.component';
import { EzEmptyStateComponent } from 'src/shared/ez-empty-state/ez-empty-state.component';
import { materialModules } from 'src/shared/material.module';
import { HeaderComponent } from '../header/header.component';
import { TaskDueDateTimePipe } from '../shared/task-due-date-time.pipe';
import { TaskGroupComponent } from './task-group/task-group.component';
import { TaskListComponent } from './task-list.component';

@NgModule({
  declarations: [
    TaskListComponent,
    TaskGroupComponent,
  ],
  imports: [
    CommonModule,
    materialModules,
    HeaderComponent,
    EzAlertComponent,
    FormsModule,
    ReactiveFormsModule,
    EzEmptyStateComponent,
    TaskDueDateTimePipe,
  ],
  exports: [
    TaskListComponent,
    TaskGroupComponent,
  ],
})
export class TaskListModule { }
